export default {
	title: 'Lista de Tipos de Dispositivos',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa'
	},
	labels: {
		deviceTypeList: 'Lista de Tipos de Dispositivos'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar'
	},
	table: {
		id: 'id',
		deviceTypeName: 'Nombre del Tipo de Dispositivo',
		icon: 'Icono',
		accThreshold: 'Umbral de Aceleracion',
		speedThreshold: 'Umbral de Velocidad',
		tempThreshold: 'Umbral de Temperatura',
		action: 'Acción'
	},
	form: {
		placeholder: {
			name: 'Nombre'
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula',
		name: 'Nombre',
		icon: 'Icono',
		accThreshold: 'Umbral de Aceleracion',
		speedThreshold: 'Umbral de Velocidad',
		tempThreshold: 'Umbral de Temperatura',
		remark: 'Observación',
		nameRequired: 'El campo obligatorio no puede estar vacío'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar'
	}
}
